import React, { useState } from 'react';
import { Field } from '../../../../helpers/rsuite/Form';
import { Radio, Modal, Button, Form } from 'rsuite';
import FormGroup from 'rsuite/esm/FormGroup';
import { cuotitasStoreService } from '../../../../services';
import { alert } from '../../../../helpers/rsuite/Alerts';
import { errorMapper, getDataError } from '../../../../helpers/ErrorMappers';
import { asyncService } from '../../../../helpers';
import { STEPS } from '../../../../constants/loanevents/steps';

const body0 = {
    width: '540px',
    padding: '0 4px'
};

const h4Style = {
    'font-weight': 'normal',
    marginBottom: '10px',
};

const personFormStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10px',
    width: '100%'
};

const defaultCheckUser = {
    firstName: '',
    lastName: '',
    document: '',
    gender: '',
    telephone: ''
};

function RepeatPersonsStep (context) {
    const [formValue, setFormValue] = useState({ selectedUser: null });

    const handleRadioChange = (value) => {
        setFormValue({ selectedUser: value });
    };

    const submit = async () => {
        try {
            context.setIsLoading(true);
            const options = {
                document: formValue?.selectedUser?.documento,
                gender: formValue?.selectedUser?.sexo
            };
            const res = await asyncService((qss) => cuotitasStoreService.getPerson(options, qss));
            context.setFormMainUser(oldPerson => ({ ...oldPerson, bornDate: parseDate(formValue?.selectedUser?.fechaNacimiento) }));

            await context.populateUser(res.loanPerson);

            context.setStep(99);
        }
        catch (e) {
            // e = errorGetPersonBank;
            console.error(e);

            const dataError = getDataError(e); // TODO: Probar borrarlo y reutilizar msg
            const msg = errorMapper(e);

            // Si la persona no existe, debemos crearla
            if (
                dataError?.error?.includes('Not found person with document') ||
                dataError?.error === 'No se encontró la persona en la base de datos.'
            ) {
                try {
                    const response = await asyncService((qss) => cuotitasStoreService.createOrModifyUser({
                        firstName: formValue?.selectedUser?.nombre,
                        lastName: formValue?.selectedUser?.apellido,
                        document: formValue?.selectedUser?.documento,
                        gender: formValue?.selectedUser?.sexo,
                        bornDate: parseDate(formValue?.selectedUser?.fechaNacimiento),
                        step: STEPS.PERSON_CREATION
                    }, qss));

                    await context.populateUser(response.loanPerson);
                    context.setStep(99);
                }
                catch (error) {
                    e.msg = msg;
                    const submitToast = () => context.submitToast(e);
                    alert(msg?.type, msg?.message, 0, 'topCenter', submitToast);
                }
            }
            else {
                e.msg = msg;
                const submitToast = () => context.submitToast(e);
                alert(msg?.type, msg?.message, 0, 'topCenter', submitToast);
            }
        }
        finally {
            context.setIsLoading(false);
        }
    };

    function parseDate (value) {
        const date = value?.split('/');
        if (value && date?.length === 3) {
            return new Date(`${date[1]}/${date[0]}/${date[2]}`);
        }
        return undefined;
    };

    function handleCancel () {
        context.setFormCheckUser(defaultCheckUser);
        context.setStep(1);
    };

    return (
        <>
            <Modal.Body className='mb-5 h-100 py-1' style={{ height: '550px' }}>
                <div style={body0}>
                    <h4 style={h4Style}>
                        Encontramos las siguientes personas con el DNI <b>{context.repeatUsers[0].documento}</b>
                    </h4>
                    <h4 style={h4Style}>Por favor seleccione el cliente a evaluar.</h4>
                    <Form fluid ref={context.formRef} formValue={formValue} onChange={setFormValue}>

                        {context.repeatUsers.map((user, index) => {
                            return (
                                <FormGroup key={index} style={personFormStyle}>
                                    <Radio
                                        value={user}
                                        checked={formValue.selectedUser === user}
                                        onChange={() => handleRadioChange(user)}
                                        name={'selectedUser'}
                                    />
                                    <Field classNameGroup='mb-0 custom-largue-field' value={`${user.nombre} ${user.apellido}`} name={`name-${index}`} disabled />
                                    <Field classNameGroup="custom-small-field" value={user.fechaNacimiento} name={`birthdate-${index}`} disabled />
                                </FormGroup>
                            );
                        })}
                    </Form>
                </div>
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button appearance='subtle' id='cancel_btn' disabled={context.isLoading} onClick={() => handleCancel()} >Cancelar</Button>
                    <Button appearance='primary' id='first_forward' disabled={context.isLoading} onClick={submit}>Siguiente</Button>
                </div>
            </Modal.Footer>
        </>
    );
};

export default RepeatPersonsStep;
